// Global Components
import * as React from 'react';

// Helpers
import {
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Components
import InputLabel from '../InputLabel';
import InputHidden from '../InputHidden';

// Types
import type {
  $InputProps,
} from '../../../types';

type $OptionalProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  labelClassName?: string;
  mask?: boolean;
  onChange?: (value: string) => unknown;
  placeholder?: string;
  required?: boolean;
  value?: null | string;
};

type $Props = $InputProps & $OptionalProps & {
  highlight: boolean;
  name: string;
};

type $State = {
  maskedValue?: null | string;
};

const maskValue = (value: string): string => `***${value.substr(-3)}`;

class InputPhoneView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    disabled: undefined,
    label: undefined,
    labelClassName: undefined,
    mask: undefined,
    onChange: undefined,
    placeholder: undefined,
    required: undefined,
    value: undefined,
  };

  constructor(props: $Props) {
    super(props);

    const {
      mask,
      value,
    } = props;
    const maskedValue = value && mask ? maskValue(value) : undefined;

    this.state = {
      maskedValue,
    };
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      mask,
      value,
    } = this.props;
    const {
      maskedValue,
    } = this.state;

    if (isDiff(
      value,
      prevProps.value,
    ) && value && mask && typeof maskedValue === 'undefined') {
      this.setState({
        maskedValue: maskValue(value),
      });
    }
  }

  getInputClasses(): string {
    const {
      disabled,
      highlight,
      isValid,
    } = this.props;

    return `border-${highlight && !isValid ? 'red-600' : 'gray-400'} ${disabled ? 'bg-gray-200' : ''} text-sm sm:text-base placeholder-gray-600 p-2 rounded-lg border w-full focus:outline-none focus:border-blue-400`;
  }

  renderInput() {
    const {
      disabled,
      name,
      onChange,
      placeholder,
      required,
      setValue,
      value,
    } = this.props;
    const {
      maskedValue,
    } = this.state;

    return (
      <input
        autoComplete={'new-password'}
        className={this.getInputClasses()}
        disabled={disabled}
        id={name}
        name={maskedValue ? `_${name}` : name}
        onChange={(e) => {
          const newValue = e.currentTarget.value;

          if (onChange) {
            onChange(newValue);
          }

          setValue(newValue);

          this.setState({
            maskedValue: null,
          });
        }}
        placeholder={placeholder}
        required={required}
        type={'text'}
        value={maskedValue || value || undefined}
      />
    );
  }

  render() {
    const {
      className,
      label,
      labelClassName,
      name,
      required,
      value,
    } = this.props;
    const {
      maskedValue,
    } = this.state;

    return (
      <div className={`InputPhone ${className || ''}`}>
        <InputLabel
          className={labelClassName}
          label={label}
          name={name}
          required={required}
        />
        {this.renderInput()}
        {maskedValue && (
          <InputHidden
            name={name}
            required={required}
            value={value}
          />
        )}
      </div>
    );
  }
}

export default InputPhoneView;
